import React from "react";
import Navbar from "./navbar";

const Header: React.FC = () => {
  return (
    <>
      <div className="w-full flex justify-center bg-red-600 sticky top-0 left-0 z-50">
        <div className="w-full max-w-[1248px] h-[114px] md:h-[74px] px-6 py-4 flex flex-col md:flex-row items-center justify-between">
          <div
            className="text-3xl text-white font-bold cursor-pointer flex items-center flex-shrink-0"
            onClick={() => (window.location.href = "/")}
          >
            <img
              src="/images/codesseek-logo.png"
              alt=""
              className="w-12 h-12 mr-2 rounded-full p-0.5"
            />
            <i>CodesSeek</i>
          </div>
          <Navbar />
        </div>
      </div>
    </>
  );
};

export default Header;
